import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
    exportDOCXExists,
    generatePermaLink,
    getContractParties,
    getUploadedBy,
    getDocxDownloadPath
} from '@Actions/contractsActions';
import { CONTRACT_SEARCH } from '@Constants/types';
import { guid } from '@Utils/commonUtils';
import ContractItem from '../ContractItem/ContractItem';
import ShowMoreItem from '../ShowMoreItem/ShowMoreItem';
import store from '@Store';
import NewDialogPopUp from '@Components/UI/NewDialogPopUp/NewDialogPopUp';
import DownloadDialog from '../DownloadDialog/DownloadDialog';
import { ContractsListWrapper } from '../../ContractsContainer.style';
import { textblocks } from 'seal-ui-components';
import { calculateDialogStartPositionFromElement } from '@Utils/domUtils';

const ContractsList = ({ showMore, ...rest }) => {
    const [dialogAnimationStartDimension, setDialogAnimationStartDimension] = useState(undefined);
    const [downloadDialogIsVisible, setDownloadDialogIsVisible] = useState(false);
    const [selectedDocId, setSelectedDocId] = useState('');
    const [uploadedByHref, setUploadedByHref] = useState();
    const [currentContractIndex, setCurrentContractIndex] = useState('');

    const totalSearchResults = useSelector(state => state.contract.totalSearchResults);

    const searchResults = useSelector(state => state.contract.searchResults);

    const onItemClick = useCallback(
        (event, { id, filename, importedAt, uploadedBy, contractIndex }) => {
            setDownloadDialogIsVisible(true);
            setDialogAnimationStartDimension(calculateDialogStartPositionFromElement(event.target));
            let myUploadedByHref = '';
            if (uploadedBy) {
                if (uploadedBy.meta) {
                    const { meta } = uploadedBy;
                    if (meta && meta.href) {
                        const { href } = meta;
                        if (href && href.length > 0) {
                            myUploadedByHref = href;
                            setUploadedByHref(href);
                        }
                    }
                }
            }

            setSelectedDocId(id);
            setCurrentContractIndex(contractIndex);

            store.dispatch({
                type: CONTRACT_SEARCH.SELECT_CONTRACT,
                payload: { id, filename, importedAt, uploadedByUrl: myUploadedByHref }
            });

            store.dispatch(exportDOCXExists(id));
            store.dispatch(generatePermaLink(id, 'original'));
            store.dispatch(generatePermaLink(id, 'docx'));
            store.dispatch(getDocxDownloadPath(id));
            store.dispatch(getContractParties(id));
            store.dispatch(getUploadedBy(myUploadedByHref));
        },
        []
    );

    const popupClosed = () => {
        store.dispatch({ type: CONTRACT_SEARCH.CLEAR_SELECTED_CONTRACT });
        setSelectedDocId('');
        setDownloadDialogIsVisible(false);
    };
    return (
        <>
            <ContractsListWrapper data-testid="contracts_wrapper" {...rest}>
                {totalSearchResults > 0 && (
                    <textblocks.Heading4 data-testid="contracts-count">{`All contracts (${totalSearchResults})`}</textblocks.Heading4>
                )}
                <div data-testid="contracts-list">
                    {searchResults &&
                        searchResults.map(value => (
                            <ContractItem
                                key={value.id}
                                onItemClick={onItemClick}
                                {...value}
                                contractIndex={guid()}
                            />
                        ))}
                </div>
                <ShowMoreItem showMore={showMore} />
            </ContractsListWrapper>
            <NewDialogPopUp
                isVisible={downloadDialogIsVisible}
                dialogAnimationStartDimension={dialogAnimationStartDimension}
            >
                {selectedDocId && (
                    <DownloadDialog
                        docId={selectedDocId}
                        popupClosed={popupClosed}
                        uploadedByHref={uploadedByHref}
                        contractIndex={currentContractIndex}
                    />
                )}
            </NewDialogPopUp>
        </>
    );
};

export default ContractsList;
